import React from 'react';

const CheckmarkIcon = (): JSX.Element => (
  <svg
    aria-hidden="true"
    width="28"
    height="27"
    viewBox="0 0 28 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="14" cy="13.5" r="13.5" fill="#EEF7FF" />
    <path
      d="M8.5 14.5L12.9629 18L18.5 7.5"
      stroke="#005FB9"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default CheckmarkIcon;
